module.exports = require('./lib/noGetters');



//////////////////
// WEBPACK FOOTER
// /Users/remi/Documents/metabase/metabase-0.28.1/node_modules/react-lazy-cache/noGetters.js
// module id = 1588
// module chunks = 7